import { BiometryType, NativeBiometric } from '@capgo/capacitor-native-biometric';
import { Capacitor } from '@capacitor/core';
import { BIOMETRIC_AUTH } from '@/utils/constants';

export interface BiometricResult {
    isAvailable: boolean;
    type: BiometryType | 'None';
    error?: string;
}

export class BiometricService {
    private static isNative = Capacitor.isNativePlatform();

    static async checkAvailability(): Promise<BiometricResult> {
        if (!this.isNative) return { isAvailable: false, type: 'None' };

        try {
            const result = await NativeBiometric.isAvailable();
            return { isAvailable: true, type: result.biometryType as BiometryType };
        } catch (e: any) {
            return { isAvailable: false, type: 'None', error: e.message };
        }
    }

    static async verifyIdentity(
        reason: string,
        title: string,
        description: string,
        negativeButtonText: string
    ): Promise<void> {
        if (!this.isNative) return;

        try {
            await NativeBiometric.verifyIdentity({ reason, title, description, negativeButtonText });
        } catch (error: any) {
            let code: string = BIOMETRIC_AUTH.CODES.AUTH_FAILED;

            if (error.code === 'UserCancellation' || error.code === 'UserFallback') {
                code = BIOMETRIC_AUTH.CODES.USER_CANCELLED;
            } else if (error.code === 'BiometryLockout') {
                code = BIOMETRIC_AUTH.CODES.LOCKOUT;
            }

            const err = new Error(error.message ?? 'Biometric authentication failed') as any;
            err.code = code;
            err.isBiometricError = true;
            throw err;
        }
    }
}